import script from "./DeletedFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./DeletedFilter.vue?vue&type=script&setup=true&lang=js"

import "./DeletedFilter.vue?vue&type=style&index=0&id=630687c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-630687c0"]])

export default __exports__